<!--
 * @Author: 冯杰
 * @Date: 2021-08-07 10:17:11
 * @LastEditors: OBKoro1
 * @LastEditTime: 2021-08-11 10:53:13
 * @FilePath: \crm2.0\found\views\cps\views\execute\display-task\table\taget.vue
-->
<template>
    <div>
        <TablePage ref="displayTaskRef" />
    </div>
</template>

<script>
import TablePage from './index.js';

export default {
  components: {
    TablePage,
  },
};
</script>
